app.controller('purchaseContributionCtrl', function ($scope, $timeout, urlServices, toaster, _VAR_GLOBAL, _API_URL, $window) {
    $scope.filter = '';
    $scope.periodStart = '';
    $scope.periodEnd = '';
    $scope.periodPicker = {
        startMonth: null,
        endMonth: null
    };
    $scope.hasSubmitted = false;
    $scope.activeSettings = null;
    $scope.pageSizeOptions = [20, 50, 100, 200, 500, 1000, 2000, 5000, 10000];
    $scope.dataList = {
        totalItems: 0,
        data: []
    };
    $scope.paginationOptions = {
        pageNumber: 1,
        pageSize: 20,
        sort: null
    };

    var filterTimer = null;

    $scope.monthPickerOptions = {
        singleDatePicker: true,
        showDropdowns: true,
        autoApply: true,
        locale: {
            format: 'MM-YYYY',
            applyClass: 'btn-green',
            fromLabel: 'Dari',
            toLabel: 'Sampai',
            cancelLabel: 'Batal',
            daysOfWeek: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
            firstDay: 1,
            monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des']
        }
    };

    function isValidPeriod(value) {
        return /^(0[1-9]|1[0-2])-\d{4}$/.test(String(value || ''));
    }

    function formatPeriodSetting(setting) {
        if (!setting) {
            return '-';
        }
        return [String(setting.mode || '-'), String(setting.lookback || '-'), String(setting.unit || '-')].join(' / ');
    }

    $scope.getActiveSettingsSummary = function () {
        var settings = $scope.activeSettings || {};
        return {
            categoryCount: (settings.contributionCategoryCodes || []).length
        };
    };

    function syncPickerToScope() {
        $scope.periodStart = $scope.periodPicker.startMonth ? moment($scope.periodPicker.startMonth).format('MM-YYYY') : '';
        $scope.periodEnd = $scope.periodPicker.endMonth ? moment($scope.periodPicker.endMonth).format('MM-YYYY') : '';
    };

    $scope.loadSettings = function () {
        urlServices.ambilData('api/report/purchase-history-settings', {}, function (err, sukses) {
            if (err) {
                $scope.activeSettings = null;
                return;
            }
            var settings = sukses.data ? sukses.data : sukses;
            $scope.activeSettings = {
                contributionCategoryCodes: settings.contributionCategoryCodes || []
            };
        });
    };

    $scope.viewData = function (pg) {
        if (!$scope.hasSubmitted) {
            return;
        }
        $scope.paginationOptions.pageNumber = pg;
        $scope.getData($scope.paginationOptions.pageSize, $scope.paginationOptions.pageNumber, $scope.filter);
    };

    $scope.getData = function (pageSize, page, searchText) {
        if (!isValidPeriod($scope.periodStart) || !isValidPeriod($scope.periodEnd)) {
            toaster.pop('error', 'Error', 'Format periode harus MM-YYYY');
            return;
        }

        var query = 'limit=' + pageSize + '&pg=' + page + '&period_start=' + encodeURIComponent($scope.periodStart) + '&period_end=' + encodeURIComponent($scope.periodEnd);
        if (searchText) {
            query += '&term=' + encodeURIComponent(searchText.toLowerCase());
        }

        urlServices.ambilData('api/report/purchase-contribution?' + query, {}, function (err, sukses) {
            if (err) {
                var message = (err && err.err) ? err.err : err;
                toaster.pop('error', 'Error', message || 'Gagal mengambil data');
                $scope.dataList.totalItems = 0;
                $scope.dataList.data = [];
            } else {
                $scope.dataList.totalItems = sukses.records || 0;
                $scope.dataList.data = sukses.data || [];
                $scope.activeSettings = sukses.settings || $scope.activeSettings;
            }
        });
    };

    $scope.tampilkan = function () {
        syncPickerToScope();
        if (!isValidPeriod($scope.periodStart) || !isValidPeriod($scope.periodEnd)) {
            toaster.pop('error', 'Error', 'Format periode harus MM-YYYY');
            return;
        }
        var start = moment('01-' + $scope.periodStart, 'DD-MM-YYYY');
        var end = moment('01-' + $scope.periodEnd, 'DD-MM-YYYY');
        if (end.isBefore(start)) {
            toaster.pop('error', 'Error', 'Periode B tidak boleh lebih kecil dari Periode A');
            return;
        }
        $scope.hasSubmitted = true;
        $scope.paginationOptions.pageNumber = 1;
        $scope.getData($scope.paginationOptions.pageSize, 1, $scope.filter);
    };

    $scope.changePageSize = function () {
        $scope.paginationOptions.pageNumber = 1;
        if ($scope.hasSubmitted) {
            $scope.getData($scope.paginationOptions.pageSize, 1, $scope.filter);
        }
    };

    $scope.excelReport = function () {
        syncPickerToScope();
        if (!isValidPeriod($scope.periodStart) || !isValidPeriod($scope.periodEnd)) {
            toaster.pop('error', 'Error', 'Format periode harus MM-YYYY');
            return;
        }
        var query = 'limit=100000&pg=1&excel=true&period_start=' + encodeURIComponent($scope.periodStart) + '&period_end=' + encodeURIComponent($scope.periodEnd);
        if ($scope.filter) {
            query += '&term=' + encodeURIComponent(String($scope.filter).toLowerCase());
        }
        $window.open(_API_URL + 'api/report/purchase-contribution?' + query);
    };

    $scope.resetFilter = function () {
        $scope.filter = '';
        $scope.periodStart = '';
        $scope.periodEnd = '';
        $scope.periodPicker = {
            startMonth: null,
            endMonth: null
        };
        $scope.hasSubmitted = false;
        $scope.activeSettings = null;
        $scope.paginationOptions.pageNumber = 1;
        $scope.paginationOptions.pageSize = 20;
        $scope.dataList.totalItems = 0;
        $scope.dataList.data = [];
        $scope.loadSettings();
    };

    $scope.onFilterChange = function () {
        if (!$scope.hasSubmitted) {
            return;
        }
        if (filterTimer) {
            $timeout.cancel(filterTimer);
        }
        filterTimer = $timeout(function () {
            $scope.viewData(1);
        }, 250);
    };

    $scope.loadSettings();
});
